import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { Guid } from '../../shared';
import { LoggingService } from '../../shared/services/logging';
import { EfaactDataService } from '../efaact.data-service';
import { CompanyAccessModel } from './company-access.model';

export const entityName = 'AuthorizedCustomers';
@Injectable({ providedIn: 'root' })
export class CompanyAccessDataService extends EfaactDataService<CompanyAccessModel> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
        this.usePostForQuery = true;
    }
    mapItems(item: CompanyAccessModel): CompanyAccessModel {
        return {
            ...item,
            id: Guid.newGuid()
        };
    }
    mapGetResponse(resp) {
        this.log.verbose({
            type: `${this.entityName}DataService(CompanyAccessDataService):mapResponse:resp`,
            resp
        });
        const result = JSON.parse(resp) as CompanyAccessModel[];
        this.log.verbose({
            type: `${this.entityName}DataService(CompanyAccessDataService):mapResponse:result`,
            result
        });
        if (Array.isArray(result)) {
            return result;
        } else {
            return [] as CompanyAccessModel[];
        }
        // return result;
    }
}
